export default __webpack_public_path__ + "static/media/PortraitOfUs.638af113.svg";